import Home from 'pages/home/home';
import Menu from 'pages/menu/menu';

export const routes = [
	{ path: '/', title: 'Home', component: Home },
	{ path: '/menu', title: 'Menu', component: Menu }
];
